var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9166 15C12.9166 16.6108 11.6108 17.9167 9.99998 17.9167C8.38915 17.9167 7.08331 16.6108 7.08331 15",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0259 14.9997H3.97406C3.15996 14.9997 2.5 14.3397 2.5 13.5256C2.5 13.1347 2.6553 12.7598 2.93174 12.4833L3.43443 11.9806C3.90327 11.5118 4.16667 10.8758 4.16667 10.2128V7.91634C4.16667 4.69468 6.77834 2.08301 10 2.08301C13.2217 2.08301 15.8333 4.69467 15.8333 7.91634V10.2128C15.8333 10.8758 16.0967 11.5118 16.5656 11.9806L17.0682 12.4833C17.3447 12.7598 17.5 13.1347 17.5 13.5256C17.5 14.3397 16.84 14.9997 16.0259 14.9997Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWhite);
export default __webpack_public_path__ + "static/media/notification-white.deb07563ea01f33f6b9f6a2700878f11.svg";
export { ForwardRef as ReactComponent };